/**
 * @desc 装板
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.InPlateDetailRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/inPlate/install`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
